import {Block} from './block';
import {BlockType} from './block-type';

export class TableRow extends Block {
  constructor(v: Partial<TableRow> = {}) {
    super(v);
    this.type = v.type ?? BlockType.TableRow;
  }
}
